import React, { Component } from 'react';
import $ from 'jquery';
import { useParams } from 'react-router-dom';

class Board extends Component {
	constructor(props) {
    	super(props);

		this.state = {
			boards: []
		}
	}
	
	componentDidMount() {
		const { type } = this.props.match.params;
		let fetchData = async () => {
            let url = `https://api.tfamily.co.kr/api/board/lists`;
			let filter = {
				page: 1,
				size: 20,
				type: type.toUpperCase() // "NOTICE"
			};
			let uk = sessionStorage.getItem('loginKey');
			const self = this;
    		let params = { "uk" : uk, ...filter };
			$.get(url, params, function(data){
				let parsedJSON = JSON.parse(data);
				self.setState({
					boards: parsedJSON.data.elements
				})
			});
        };
        fetchData();
	}
	render() {
		const { type } = this.props.match.params;
		return (<>
			<div className="board_title">
				<div className="board_notice_title" onClick={()=>{
					//window.history.back();
					window.location.href = "/";
				}}>
					<i className="fas fa-chevron-left" /> {type === "notice" ? "공지사항" : "이벤트"} 
				</div>
				<br/>
				<div className="min-board-height">
					<table className="board_notice_table table table-hover">
						<thead>
						<tr>
							<th className="text-center" width="80">번호</th>
							<th>제목</th>
							<th width="120">작성일</th>
						</tr>
						</thead>
						<tbody>
							{this.state.boards.map((item, itemKey)=>{
								return <tr key={'itemKey' + itemKey}>
									<td style={{textAlign:'center'}}>
										{this.state.boards.length - itemKey}
									</td>
									<td onClick={()=>{
										window.location.href = "/boardview/" + item.idx;
									}}>{
										item.title
									}</td>
									<td style={{width:'120px', fontSize: '12px'}}>
										{item.created_at.substring(0,10)}
									</td>
								</tr>;
							})}
						</tbody>
					</table>
				</div>
			</div>
		</>);
	}
	
}

export default Board;